// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Sxt4","description":"PatientConsentPreview_description__23ikA"};